<template lang="pug">
	.reaction
		label.radio
			input(
				type="radio"
				v-bind:name="getUniqueInformationName"
				:disabled="answered == true"
				v-model="value"
				:selected="false"
			)
			| &nbsp; {{ getContent }}
</template>
<script>
	import store from '@/store';
    import { mapGetters } from 'vuex'
	export default {
		name: 'Radio',
		props: {
			inputType: {
				type: String,
				required: true
			},
			content: {
				type: Object,
				required: true
			},
			information: {
				type: Object,
				required: true
			},
			answered: {
				type: Boolean
			},
			reaction: {
				type: Object,
				required: true
			},
			section: {
                type: Object,
                required: true
            },
            answer: {
				type: undefined
			},
		},
		computed: {
			getUniqueInformationName() {
				return 'single-choice-ID' + this.information.id
			},
			getContent() {
				return this.content.title
			},
			value: {
                get() {
                    return false
                },
                set(value) {
                    const payload = {
                        value: this.content.title,
                        page: parseInt(this.currentPageId),
                        information: this.information,
                        reaction: this.reaction,
                        section: this.section
                    }
                    this.$emit('answer', this.reaction.id);

                    store.commit(`currentPage/evaluationReactionInputFieldValue`, payload)
                }
            },
            ...mapGetters({
                currentPageId: 'currentPage/id',
            })
		}
	}
</script>
<style lang="sass" scoped>
</style>